import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer>
    <p>&copy; 2024 Department of Technical Education. All rights reserved.</p>
    <p>Contact: <a href="mailto:dte_raj@rajasthan.gov.in">dte_raj@rajasthan.gov.in</a> | Phone: 0291-2434395</p>
  </footer>
);

export default Footer;
